import React, { useContext, useEffect, useMemo, useState } from "react";
import { TWorkingDay, TWorkingTime } from "../../../../types/items";
import { Table, Td, TimeInput, Tr, Wrapper } from "./styled";
import { Translater } from "../../../../config";
import * as Contexts from "../../../../contexts";

type TProps = {
  initialData?: TWorkingTime;
  setData?: React.Dispatch<React.SetStateAction<TWorkingTime | undefined>>;
  title?: string;
};

export const WorkingTable = ({ initialData, setData, title }: TProps) => {
  const { language } = useContext(Contexts.LanguageContext);
  const [localData, setLocalData] = useState<TWorkingTime | undefined>(
    initialData
  );

  const days: (keyof TWorkingTime)[] = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const dayNames = useMemo<Record<keyof TWorkingTime, string>>(
    () => ({
      monday: Translater.TableTitles.daysDict.monday[language.slug],
      tuesday: Translater.TableTitles.daysDict.tuesday[language.slug],
      wednesday: Translater.TableTitles.daysDict.wednesday[language.slug],
      thursday: Translater.TableTitles.daysDict.thursday[language.slug],
      friday: Translater.TableTitles.daysDict.friday[language.slug],
      saturday: Translater.TableTitles.daysDict.saturday[language.slug],
      sunday: Translater.TableTitles.daysDict.sunday[language.slug],
    }),
    [language.slug]
  );



  useEffect(() => {
  if (initialData) {
    setLocalData(initialData);
  }
  }, [initialData]);
  
 const handleChange = (
  day: keyof TWorkingTime,
  field: keyof TWorkingDay,
  value: string
) => {
const emptyDay = { start: "", end: "" };

const updater = (prev: TWorkingTime = {
  monday: emptyDay,
  tuesday: emptyDay,
  wednesday: emptyDay,
  thursday: emptyDay,
  friday: emptyDay,
  saturday: emptyDay,
  sunday: emptyDay,
}): TWorkingTime => ({
  ...prev,
  [day]: {
    ...prev[day],
    [field]: value,
  },
});

  if (setData) setData(updater);
  setLocalData(updater);
};

  return (
    <Wrapper>
      {title && <h4 style={{ margin: 0 }}>{title}</h4>}
      <Table>
        <tbody>
          {days.map((day) => {
            const start = localData?.[day]?.start || "";
            const end = localData?.[day]?.end || "";
            return (
              <Tr key={day}>
                <Td>{dayNames[day]}</Td>
                <Td>
                  <TimeInput
                    type="time"
                    value={start}
                    onChange={(e) => handleChange(day, "start", e.target.value)}
                  />
                </Td>
                <Td style={{ width: 10, textAlign: "center" }}>—</Td>
                <Td>
                  <TimeInput
                    type="time"
                    value={end}
                    onChange={(e) => handleChange(day, "end", e.target.value)}
                  />
                </Td>
              </Tr>
            );
          })}
        </tbody>
      </Table>
    </Wrapper>
  );
};
